// 재고 판정의 단일 출처.
// 예전에는 POS 안에서만 세 가지 기준이 섞여 있었다 — 타일 비활성은 stock === 0,
// 장바구니 차단은 stock <= 0 이라, 음수 재고 상품은 눌리는데 담기지 않았다.
// 무한 재고가 생기면서 판정이 더 갈라지므로 여기로 모은다.

export const isUnlimitedStock = (product) => product?.unlimited_stock === true;

export const isSoldOut = (product) =>
  !isUnlimitedStock(product) && Number(product?.stock) <= 0;

// 이미 담은 수량으로 재고를 다 썼는지. 무한이면 항상 더 담을 수 있다.
export const isStockExhausted = (product, quantity) =>
  !isUnlimitedStock(product) && quantity >= Number(product?.stock);
